// extracted by mini-css-extract-plugin
module.exports = {"errors":"index_errors_7FFns","container":"index_container_1jtGL","footerNav":"index_footerNav_3YU0h"};